import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/white_content_copy_24dp.png'
import _imports_1 from '@/assets/icons/white_send_24dp.png'


const _withScopeId = n => (_pushScopeId("data-v-25cf5df3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body-container" }
const _hoisted_2 = { class: "fs-15 fw-700 fc-primary" }
const _hoisted_3 = { class: "fs-20 fw-700 mt-12" }
const _hoisted_4 = { class: "fs-15 mt-20" }
const _hoisted_5 = { class: "fs-15 fw-700 mt-24" }
const _hoisted_6 = { class: "flex-center mt-12" }
const _hoisted_7 = {
  class: "input-with-icon",
  style: {"width":"30rem"}
}
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icons_white_content_copy_24dp",
  class: "icon-20 mr-12"
}, null, -1))
const _hoisted_10 = { class: "fs-16 fw-700" }
const _hoisted_11 = {
  class: "fs-15 fw-700",
  style: {"margin-top":"9rem"}
}
const _hoisted_12 = { class: "flex-center mt-12" }
const _hoisted_13 = { style: {"width":"30rem"} }
const _hoisted_14 = { class: "text-validate" }
const _hoisted_15 = {
  key: 0,
  class: "top label"
}
const _hoisted_16 = {
  key: 1,
  class: "top label"
}
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "icons_white_send_24dp",
  class: "icon-20 mr-12"
}, null, -1))
const _hoisted_19 = { class: "fs-16 fw-700" }
const _hoisted_20 = {
  key: 0,
  class: "fs-20 fw-700"
}
const _hoisted_21 = { class: "mt-20" }
const _hoisted_22 = { class: "taqble-referrals" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td"),
    /*#__PURE__*/_createElementVNode("td", { style: {"width":"12rem"} }),
    /*#__PURE__*/_createElementVNode("td"),
    /*#__PURE__*/_createElementVNode("td")
  ])
], -1))
const _hoisted_24 = { class: "date" }
const _hoisted_25 = { class: "ellipsis" }
const _hoisted_26 = { class: "name" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ellipsis" }, /*#__PURE__*/_toDisplayString(`Signed up`))
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "credits" }, /*#__PURE__*/_toDisplayString(`+10 Credits`), -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("myAccount.refer_a_friend.Special_offer")), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("myAccount.refer_a_friend.Refer_a_friend_and")), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("myAccount.refer_a_friend.When_a_friend_signs")), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("myAccount.refer_a_friend.Your_unique_referral_link")) + ": ", 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            class: "input input-44 ellipsis",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.refferralLink) = $event)),
            type: "text",
            placeholder: _ctx.$t('placeholder.Coupon_code'),
            disabled: ""
          }, null, 8, _hoisted_8), [
            [_vModelText, _ctx.refferralLink]
          ])
        ]),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyLink())),
          class: "btn btn-primary ml-12",
          style: {"height":"4.4rem","width":"8.6rem"}
        }, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("btn.Copy")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("myAccount.refer_a_friend.Email_your_invite")) + ": ", 1),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (_ctx.validateInviteEmail && !_ctx.inviteEmailErrorMsg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t("myAccount.refer_a_friend.we_do_not_recognise")) + ": ", 1))
              : _createCommentVNode("", true),
            (_ctx.validateInviteEmail && _ctx.inviteEmailErrorMsg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.inviteEmailErrorMsg) + ": ", 1))
              : _createCommentVNode("", true)
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "input input-44",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inviteEmail) = $event)),
            type: "email",
            placeholder: _ctx.$t('placeholder.email_email_com')
          }, null, 8, _hoisted_17), [
            [_vModelText, _ctx.inviteEmail]
          ])
        ]),
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendInvite())),
          class: "btn btn-primary ml-12",
          style: {"height":"4.4rem","width":"8.6rem"}
        }, [
          _hoisted_18,
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("btn.Send")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      (_ctx.referrals && _ctx.referrals.length != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t("myAccount.refer_a_friend.Successful_Referrals")), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("table", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referrals, (value, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index + '_tr'
              }, [
                _createElementVNode("td", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.referralDate(value.createdAt)), 1)
                ]),
                _createElementVNode("td", _hoisted_26, _toDisplayString(value.firstName + " " + String(value.lastName)[0]), 1),
                _hoisted_27,
                _hoisted_28
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}